import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBusinessPostingGroup } from "src/models/General/BusinessPostingGroup.models";

interface businessPostingGroupstate {
  businessPostingGroups: IBusinessPostingGroup[];
  businessPostingGroupToEdit: IBusinessPostingGroup | null;
}

const initialState: businessPostingGroupstate = {
  businessPostingGroups: [],
  businessPostingGroupToEdit: null,
};

const businessPostingGroupSlice = createSlice({
  name: "BusinessPostingGroup",
  initialState,
  reducers: {
    setBusinessPostingGroupList: (
      state,
      action: PayloadAction<IBusinessPostingGroup[]>
    ) => {
      state.businessPostingGroups = action.payload;
    },
    concatListBusinessPostingGroup: (
      state: businessPostingGroupstate,
      action: PayloadAction<IBusinessPostingGroup[]>
    ) => {
      state.businessPostingGroups = [
        ...state.businessPostingGroups.concat(action.payload),
      ];
    },
    setBusinessPostingGroupToEdit: (
      state,
      action: PayloadAction<IBusinessPostingGroup | null>
    ) => {
      state.businessPostingGroupToEdit = action.payload;
    },
    addBusinessPostingGroup: (
      state,
      action: PayloadAction<IBusinessPostingGroup>
    ) => {
      state.businessPostingGroups.push(action.payload);
    },
    updateBusinessPostingGroup: (
      state,
      action: PayloadAction<IBusinessPostingGroup>
    ) => {
      let itemIndex = state.businessPostingGroups.findIndex(
        item =>
          item.generalBusinessPostingGroupId ===
          action.payload.generalBusinessPostingGroupId
      );
      if (itemIndex !== -1)
        state.businessPostingGroups[itemIndex] = action.payload;
    },
    deleteBusinessPostingGroup: (state, action: PayloadAction<number>) => {
      const newArray = state.businessPostingGroups.filter(
        item => item.generalBusinessPostingGroupId !== action.payload
      );
      state.businessPostingGroups = newArray;
    },
  },
});

export const {
  setBusinessPostingGroupList,
  concatListBusinessPostingGroup,
  setBusinessPostingGroupToEdit,
  addBusinessPostingGroup,
  updateBusinessPostingGroup,
  deleteBusinessPostingGroup,
} = businessPostingGroupSlice.actions;

export default businessPostingGroupSlice.reducer;
